import { c as _c } from "react/compiler-runtime";
import { Box, Link, Typography } from '@mui/material';
import { BreadcrumbLinkedData } from './BreadcrumbLinkedData';
import BreadcrumbPath from './BreadcrumbPath';
import { type BreadcrumbSource, CREDIT_CARDS_HUB, chevronSize, HOME_PAGE_URL } from './constants';
interface BreadcrumbRedesignedProps {
  columnGap?: number | {
    xs: number;
    sm?: number;
    md: number;
  };
  homeIconColors?: {
    color: string;
    hoverColor: string;
  };
  pathColors?: {
    color: string;
    hoverColor: string;
  };
  maxWidth?: `${number}rem` | {
    xs?: `${number}rem`;
    sm?: `${number}rem`;
    md?: `${number}rem`;
  };
  prefixPath?: string;
  slug?: string;
  source: BreadcrumbSource;
  text: string;
}

// This is the redesigned breadcrumb component for site hierarchy

export function BreadcrumbRedesigned(t0) {
  const $ = _c(51);
  const {
    columnGap: t1,
    homeIconColors: t2,
    pathColors: t3,
    maxWidth,
    prefixPath,
    slug,
    source,
    text
  } = t0;
  const columnGap = t1 === undefined ? 3 : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? {
      color: "primary.dark",
      hoverColor: "greens.light"
    } : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const homeIconColors = t4;
  let t5;
  if ($[2] !== t3) {
    t5 = t3 === undefined ? {
      color: "text.secondary",
      hoverColor: "primary.main"
    } : t3;
    $[2] = t3;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const pathColors = t5;
  let t6;
  if ($[4] !== columnGap) {
    t6 = {
      marginY: 0,
      paddingLeft: 0,
      display: "flex",
      alignItems: "center",
      columnGap,
      listStyle: "none"
    };
    $[4] = columnGap;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "inline"
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== homeIconColors.hoverColor) {
    t8 = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "18px",
      padding: "5px",
      borderRadius: "50%",
      "&:hover": {
        backgroundColor: homeIconColors.hoverColor
      }
    };
    $[7] = homeIconColors.hoverColor;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== homeIconColors.color) {
    t9 = <Box aria-hidden="true" component="span" className="mask-icon mask-icon-home" sx={{
      width: "1em",
      height: "1em",
      backgroundColor: homeIconColors.color
    }} />;
    $[9] = homeIconColors.color;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8 || $[12] !== t9) {
    t10 = <Box component="li" sx={t7}><Link href={HOME_PAGE_URL} aria-label="NerdWallet Homepage" title="NerdWallet Homepage" sx={t8}>{t9}</Link></Box>;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      display: "inline-block"
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Box component="li" aria-hidden="true" role="presentation" sx={t11}><span className="mask-icon mask-icon-chevron-right" style={{
        width: chevronSize,
        height: chevronSize
      }} /></Box>;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      display: "flex",
      alignItems: "center"
    };
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== pathColors.hoverColor) {
    t14 = {
      color: pathColors.hoverColor,
      textDecoration: "underline"
    };
    $[17] = pathColors.hoverColor;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== pathColors.color || $[20] !== t14) {
    t15 = <Box component="li" sx={t13}><Typography variant="breadcrumb" title={CREDIT_CARDS_HUB.title}><Link aria-label={CREDIT_CARDS_HUB.linkTitle} href={`${HOME_PAGE_URL}${CREDIT_CARDS_HUB.link}`} fontWeight={700} fontSize={10} sx={{
          color: pathColors.color,
          "&:hover": t14
        }}>{CREDIT_CARDS_HUB.label}</Link></Typography></Box>;
    $[19] = pathColors.color;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== pathColors || $[23] !== slug || $[24] !== source) {
    t16 = <BreadcrumbPath pathColors={pathColors} source={source} slug={slug} />;
    $[22] = pathColors;
    $[23] = slug;
    $[24] = source;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      display: {
        xs: "none",
        sm: "inline"
      }
    };
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Box component="li" aria-hidden="true" role="presentation" sx={t17}><span className="mask-icon mask-icon-chevron-right" style={{
        width: chevronSize,
        height: chevronSize
      }} /></Box>;
    $[27] = t18;
  } else {
    t18 = $[27];
  }
  let t19;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      display: {
        xs: "none",
        sm: "flex"
      }
    };
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  const t20 = maxWidth || "22.5rem";
  let t21;
  if ($[29] !== t20) {
    t21 = {
      width: "auto",
      textOverflow: "ellipsis",
      maxWidth: t20,
      overflow: "hidden",
      whiteSpace: "nowrap"
    };
    $[29] = t20;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  let t22;
  if ($[31] !== text) {
    t22 = text.toUpperCase();
    $[31] = text;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== t21 || $[34] !== t22 || $[35] !== text) {
    t23 = <Box component="li" sx={t19}><Typography variant="breadcrumb" title={text} aria-current="page" sx={t21}>{t22}</Typography></Box>;
    $[33] = t21;
    $[34] = t22;
    $[35] = text;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t10 || $[38] !== t15 || $[39] !== t16 || $[40] !== t23 || $[41] !== t6) {
    t24 = <nav aria-label="Breadcrumb"><Box component="ol" sx={t6}>{t10}{t12}{t15}{t16}{t18}{t23}</Box></nav>;
    $[37] = t10;
    $[38] = t15;
    $[39] = t16;
    $[40] = t23;
    $[41] = t6;
    $[42] = t24;
  } else {
    t24 = $[42];
  }
  let t25;
  if ($[43] !== prefixPath || $[44] !== slug || $[45] !== source || $[46] !== text) {
    t25 = <BreadcrumbLinkedData id="breadcrumbs-linked-data" prefixPath={prefixPath} text={text} source={source} slug={slug} />;
    $[43] = prefixPath;
    $[44] = slug;
    $[45] = source;
    $[46] = text;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  let t26;
  if ($[48] !== t24 || $[49] !== t25) {
    t26 = <>{t24}{t25}</>;
    $[48] = t24;
    $[49] = t25;
    $[50] = t26;
  } else {
    t26 = $[50];
  }
  return t26;
}